// ── 모달·폼 스타일 ────────────────────────────────────────────────────────────
import { stdModalHeaderBg } from '../adminlayout/designStandard';

// ── 확인 모달 스타일 (계약취소/삭제 확인용 간소 모달) ─────────────────────────
export const confirmBoxStyle = {
  background: 'var(--bg-card)', borderRadius: 16, width: '100%', maxWidth: 400,
  boxShadow: '0 16px 48px rgba(0,0,0,0.2)',
  display: 'flex', flexDirection: 'column', overflow: 'hidden',
};
// 모달 헤더 표준(2026-08-31): 밴드는 항상 검정 #0f172a.
// 색 인자는 기존 호출처 호환을 위해 받기만 하고 무시한다.
export const confirmHeaderStyle = (_color) => ({
  background: stdModalHeaderBg, color: '#fff',
  padding: '14px 20px', fontWeight: 800, fontSize: 15,
});
export const confirmBodyStyle   = { padding: '16px 20px', display: 'grid', gap: 8 };
export const confirmMsgStyle    = { margin: 0, fontSize: 14, color: 'var(--text)', lineHeight: 1.6 };
export const confirmSubStyle    = { margin: 0, fontSize: 12, color: 'var(--text-muted)', lineHeight: 1.6 };
export const confirmFooterStyle = {
  display: 'flex', justifyContent: 'flex-end', gap: 8,
  padding: '12px 20px', borderTop: '1px solid var(--bg-subtle)',
};
export const confirmCancelBtnStyle = {
  border: '1px solid var(--border)', borderRadius: 8, padding: '7px 16px',
  background: 'var(--bg-card)', color: 'var(--text-sub)', fontWeight: 600, fontSize: 13, cursor: 'pointer',
};
export const confirmOkBtnStyle = (color) => ({
  border: 'none', borderRadius: 8, padding: '7px 18px',
  background: color, color: '#fff', fontWeight: 700, fontSize: 13, cursor: 'pointer',
});

// ── 모달 오버레이·박스 ────────────────────────────────────────────────────────
export const overlayStyle = {
  position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.55)',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  zIndex: 2000, padding: 16,
  boxSizing: 'border-box',
  backdropFilter: 'blur(2px)',
};
export const modalBoxStyle = {
  background: 'var(--bg-subtle)', borderRadius: 20,
  width: 'min(560px, calc(100vw - 24px))',
  maxWidth: 'calc(100vw - 24px)',
  boxShadow: '0 24px 64px rgba(0,0,0,0.22)',
  display: 'flex', flexDirection: 'column',
  maxHeight: 'min(92vh, calc(100dvh - 24px))',
  overflow: 'hidden',
};

// 헤더
export const modalHeaderStyle = {
  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
  padding: '18px 22px',
  borderRadius: '20px 20px 0 0',
  flexShrink: 0,
};
export const headerIconBox = {
  width: 38, height: 38,
  background: 'rgba(255,255,255,0.18)',
  borderRadius: 11,
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  flexShrink: 0,
};
export const modalCloseBtnStyle = {
  background: 'rgba(255,255,255,0.15)', border: 'none',
  width: 32, height: 32, borderRadius: 9,
  cursor: 'pointer', color: '#fff', fontSize: 13, fontWeight: 700,
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  flexShrink: 0,
};

// 바디
export const modalBodyStyle = {
  padding: '14px 16px', overflowY: 'auto', display: 'grid', gap: 10, flexGrow: 1,
  boxSizing: 'border-box', minWidth: 0,
};

// 섹션 카드
export const sectionCard = {
  background: 'var(--bg-card)', borderRadius: 14, border: '1px solid var(--border)',
  padding: '14px 16px',
  display: 'grid', gap: 12,
  width: '100%', minWidth: 0, boxSizing: 'border-box',
};
export const sectionTitleBar = (color) => ({
  display: 'flex', alignItems: 'center', gap: 7,
  fontSize: 12, fontWeight: 800, color: color,
  paddingBottom: 8, borderBottom: `1.5px solid ${color}25`,
  letterSpacing: '0.03em',
});
export const sectionDot = (color) => ({
  display: 'inline-block', width: 7, height: 7,
  borderRadius: '50%', background: color, flexShrink: 0,
});

// 서비스 상품 구역 — 다크모드 대응: 하드코딩 라이트컬러 → rgba
export const serviceZone = {
  background: 'rgba(59,130,246,0.08)', borderRadius: 11, padding: '12px 14px',
  border: '1px solid rgba(59,130,246,0.25)', display: 'grid', gap: 8,
};
export const serviceZoneTitle = {
  display: 'flex', alignItems: 'center', gap: 7,
  fontSize: 12, fontWeight: 800, color: 'var(--text-sub)',
};
export const optionalBadge = {
  fontSize: 10, fontWeight: 600, color: '#60a5fa',
  background: 'rgba(59,130,246,0.15)', borderRadius: 6, padding: '1px 7px',
};

// 폼 필드
export const twoColStyle    = { display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)', gap: 10, minWidth: 0 };
// var(--text-muted)는 다크모드에서 #4b5878으로 뒤집혀 배경에 묻힘 → var(--text-sub) 사용
export const fieldLabelStyle = { fontSize: 11, fontWeight: 700, color: 'var(--text-sub)' };
export const inputStyle     = {
  border: '1px solid var(--border)', borderRadius: 9, padding: '7px 9px',
  fontSize: 11, color: 'var(--text)', outline: 'none',
  width: '100%', boxSizing: 'border-box', background: 'var(--bg-card)',
};

// 상품 칩
export const chipRowStyle = { display: 'flex', flexWrap: 'wrap', gap: 6 };
// 비활성 칩 색상: var(--text-muted) 다크모드에서 묻힘 → var(--text-sub)
export const chipBtn      = (active, color) => ({
  border:     `1.5px solid ${active ? color : 'var(--border)'}`,
  borderRadius: 100, padding: '5px 13px', fontSize: 12, fontWeight: 600,
  cursor: 'pointer',
  background: active ? color    : 'var(--bg-subtle)',
  color:      active ? '#fff'   : 'var(--text-sub)',
  display: 'flex', alignItems: 'center',
});

// 수량 행
export const countListBox = {
  background: 'var(--bg-subtle)', borderRadius: 10, padding: '8px 10px',
  display: 'grid', gap: 5, marginTop: 4,
};
export const countRow = {
  display: 'flex', alignItems: 'center', gap: 8,
  background: 'var(--bg-card)', borderRadius: 8, padding: '6px 10px',
  border: '1px solid var(--border)',
};
export const colorDot = (color) => ({
  width: 7, height: 7, borderRadius: '50%', background: color, flexShrink: 0,
});
export const countLabel    = { fontSize: 12, fontWeight: 600, color: 'var(--text-sub)', flex: 1 };
export const countNumInput = {
  border: '1px solid var(--border)', borderRadius: 7, padding: '4px 8px',
  fontSize: 13, color: 'var(--text)', background: 'var(--bg-card)',
  width: 68, textAlign: 'right', outline: 'none',
};
export const unitLabel = { fontSize: 12, color: 'var(--text-sub)', fontWeight: 500 };

// 에러 메시지 — 하드코딩 흰배경 → rgba로 대체 (다크모드 대응)
export const errMsgStyle = {
  fontSize: 11, color: '#ef4444', fontWeight: 600,
  background: 'rgba(239,68,68,0.08)', borderRadius: 6, padding: '4px 8px',
};

// 푸터
export const modalFooterStyle = {
  display: 'flex', justifyContent: 'flex-end', gap: 8,
  padding: '13px 18px 16px', borderTop: '1px solid var(--border)',
  background: 'var(--bg-card)', borderRadius: '0 0 20px 20px', flexShrink: 0,
};
export const cancelBtnStyle = {
  border: '1px solid var(--border)', borderRadius: 9, padding: '9px 18px',
  background: 'var(--bg-card)', color: 'var(--text-sub)', fontWeight: 600, fontSize: 13, cursor: 'pointer',
};
export const saveBtnStyle = (isNew, isContracted) => ({
  border: 'none', borderRadius: 9, padding: '9px 22px',
  background: isNew
    ? 'linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%)'
    : isContracted
      ? '#16a34a'
      : 'linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%)',
  color: '#fff', fontWeight: 700, fontSize: 13, cursor: 'pointer',
});
